"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureProducedInVariantSuggestion = instanceOfFeatureProducedInVariantSuggestion;
exports.FeatureProducedInVariantSuggestionFromJSON = FeatureProducedInVariantSuggestionFromJSON;
exports.FeatureProducedInVariantSuggestionFromJSONTyped = FeatureProducedInVariantSuggestionFromJSONTyped;
exports.FeatureProducedInVariantSuggestionToJSON = FeatureProducedInVariantSuggestionToJSON;
exports.FeatureProducedInVariantSuggestionToJSONTyped = FeatureProducedInVariantSuggestionToJSONTyped;
/**
 * Check if a given object implements the FeatureProducedInVariantSuggestion interface.
 */
function instanceOfFeatureProducedInVariantSuggestion(value) {
    if (!('feature' in value) || value['feature'] === undefined)
        return false;
    return true;
}
function FeatureProducedInVariantSuggestionFromJSON(json) {
    return FeatureProducedInVariantSuggestionFromJSONTyped(json, false);
}
function FeatureProducedInVariantSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feature': json['feature'],
    };
}
function FeatureProducedInVariantSuggestionToJSON(json) {
    return FeatureProducedInVariantSuggestionToJSONTyped(json, false);
}
function FeatureProducedInVariantSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'feature': value['feature'],
    };
}
//# sourceMappingURL=featureProducedInVariantSuggestion.js.map